export default __webpack_public_path__ + "static/media/important.c6839670.svg";